import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { companyCustomerType } from '../../types';

type customersProps = {
    customers: Array<companyCustomerType>,
    is_adding_customer: boolean;
    is_loading_customers: boolean;
    is_updating_customer: boolean;
};

const initialState: customersProps = {
    customers: [],
    is_adding_customer: false,
    is_loading_customers: false,
    is_updating_customer: false,
};

const customersSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        getCustomersSuccess: (state, actions: PayloadAction<Array<companyCustomerType>>) => {
            return {
                ...state,
                customers: actions.payload
            };
        },
        onLoadingCustomers: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_customers: actions.payload
            };
        },
        onAddingCustomer: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_customer: actions.payload
            };
        },
        onUpdatingCustomer: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_customer: actions.payload
            };
        },
    }
});

export const { getCustomersSuccess, onLoadingCustomers, onAddingCustomer, onUpdatingCustomer } = customersSlice.actions;

export default customersSlice.reducer;